<template>
  <b-modal
    title="Selecionar segmentos"
    no-close-on-backdrop
    size="lg"
    ok-only
    centered
    header-bg-variant="orange"
    header-text-variant="light"
    v-model="open"
    ok-title="Salvar"
    ok-variant="success"
    @ok="save"
  >
    <b-form-checkbox-group
      v-model="selected"
      :options="options"
      value-field="id"
      text-field="nome"
      stacked
      size="lg"
    >
    </b-form-checkbox-group>
  </b-modal>
</template>

<script>

export default {
  name: 'ModalSelectSegment',
  emits: ['addSegment'],

  data() {
    return {
      options:[],
      selected:[],
      open: false,
    };
  },

  methods: {
    toggleOpen({ segment = '' }) {
      this.open = !this.open;
      this.options = segment;
    },
    save(){
      this.$emit('addSegment', this.selected);
      this.open = false;
    }
  }
}
</script>
